import styled from '@mui/system/styled';

export const WidgetFooterCnt = styled('div')({
  padding: '16px 0 0 0',
  borderTop: '1px solid #eee',
});
